import React, { useState } from 'react';
import envelopeImg from '../assets/mailIcon.svg';

const styles = `
.consultation-section {
  padding: 4rem 1rem;
}

.consultation {
  background: #27409C;
  padding: 4rem 2rem;
  border-radius: 1.5rem;
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 3rem;
  min-height: 420px;
  box-sizing: border-box;
  font-family: 'Titillium Web', sans-serif;
}

.consultation-image {
  flex: 1 1 250px;
  display: flex;
  justify-content: center;
  position: relative;
}

.consultation-image img {
  max-width: 70%;
  height: auto;
}

.consultation-image .shadow {
  position: absolute;
  bottom: -0.6rem;
  left: 0;
  right: 0;
  width: 36%;
}

.consultation-content {
  flex: 2 1 400px;
  color: #fff;
  margin-left: 3rem;
}

.consultation-content p {
  font-size: 1.2rem;
  margin-bottom: 1.5rem;
  line-height: 1.4;
}

.consultation-form {
  display: flex;
  gap: 1rem;
  flex-direction: column;
  justify-content: center;
}

.consultation-form input {
  flex: 1 1 100%;
  padding: 0.75rem 1rem;
  border: 1px solid #fff;
  border-radius: 6px;
  background: transparent;
  color: #fff;
  font-size: 1rem;
  outline: none;
}

.consultation-form input::placeholder {
  color: rgba(255,255,255,0.7);
}

.consultation-form button {
  padding: 0.75rem 2rem;
  background: #fff;
  color: #27409C;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  font-size: 1rem;
  margin-top: 0.5rem;
}

/* 📱 Mobile-only (desktop unchanged) */
@media (max-width: 768px) {
  .consultation-section {
    padding: 3.5rem 1rem;
  }

  .consultation {
    flex-direction: column;
    text-align: left;
    gap: 0.5rem;
    padding: 0.9rem 1rem 0.25rem; /* tighter bottom padding */
    min-height: 0;               /* no enforced height */
    height: auto;                /* grow only as needed */
    align-items: stretch;        /* avoid extra vertical space */
  }

  .consultation-image {
    flex: 0 0 auto;
    margin-top: 12px;            /* small gap before icon */
  }

  .consultation-image img {
    max-width: 100%;
    height: 120px;
       margin-top: 20px;
    margin-bottom: 46px;         /* reduced (was 44px) */
  }

  .consultation-content {
    margin-left: 0;
    flex: 0 1 auto;              /* reset desktop flex that caused tall column */
  }

  .consultation-content p {
    font-size: 1rem;
    margin-bottom: 1.25rem;      /* tighter copy-to-form spacing */
    line-height: 1.35;
    text-align: left;
  }

  /* compact inline error/success */
  .consultation-form p {
    margin: 0.35rem 0 0.25rem;
    font-size: 0.95rem;
  }

  .consultation-form {
    width: 100%;
    align-items: stretch;        /* full width fields & button */
    gap: 0.5rem;
  }

  .consultation-form input {
    width: 100%;
    padding: 0.6rem 1rem;
  }

  .consultation-form button {
    width: 100%;
    padding: 0.6rem 1rem;
    margin-bottom : 2.5rem;
    margin-top: 0.5rem;          /* slightly tighter above button */
  }

  .consultation-image .shadow {
    display: none;
  }
}
`;

export default function Consultation() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    setError('');
    setSuccessMessage('');

    if (!email || !/\S+@\S+\.\S+/.test(email)) {
      setError('Please enter a valid email address');
      return;
    }

    const payload = {
      email: email,
      mobile: '0000000000',
    };

    try {
      const response = await fetch('https://app.yaper.co/api/v2/retail/newsletter', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        setSuccessMessage('Thank you for subscribing!');
        setEmail('');
      } else {
        const errorText = await response.text();
        setError('Something went wrong. Please try again later.');
        console.error('Error response:', errorText);
      }
    } catch (error) {
      setError('An error occurred while sending the request.');
      console.error('Error sending request:', error);
    }
  };

  return (
    <>
      <style>{styles}</style>
      <section className="consultation-section">
        <div className="consultation">
          <div className="consultation-image">
            <img src={envelopeImg} alt="Envelope icon" />
          </div>
          <div className="consultation-content">
            <p>
              Subscribe for card tips & exclusive offers, tailored just for you.
            </p>
            <form className="consultation-form" onSubmit={handleSubmit}>
              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              {error && <p style={{ color: 'red' }}>{error}</p>}
              {successMessage && <p style={{ color: 'white' }}>{successMessage}</p>}
              <button type="submit">SUBSCRIBE</button>
            </form>
          </div>
        </div>
      </section>
    </>
  );
}
